<!-- Botones de capas: uno por tipo con datos (ver/ocultar) y, debajo, el de
     agrupar con el color de los clusters de esa capa -->
@if (capas.length) {
  <div class="mapa-capas" role="toolbar" aria-label="Capas del mapa">
    @for (capa of capas; track capa.clave) {
      <div class="mapa-capa">
        <button
          irxBotonIcono="mapa"
          alternable
          [activo]="capa.visible"
          (click)="capa.alternar()"
          [tooltip]="capa.label + ' (' + formatoCantidad(capa.cantidad) + ')'"
          tooltipPosition="below"
          [aria-label]="capa.label"
        >
          <mat-icon class="material-symbols-outlined">
            {{ capa.icono }}
          </mat-icon>
        </button>
        <button
          irxBotonIcono="anillo"
          alternable
          [activo]="capa.agrupada"
          [style.--color-anillo]="capa.colorCluster"
          (click)="capa.alternarAgrupado()"
          [tooltip]="'Agrupar ' + capa.label.toLowerCase()"
          tooltipPosition="below"
        ></button>
      </div>
    }
  </div>
}

<app-mapa-facil-v2
  mapId="MapaOlComponent"
  [allowedEntityTypes]="allowedTypes"
  (mapReady)="onMapReady($event)"
></app-mapa-facil-v2>
